import React, {useMemo, useState} from 'react';
import {useDeletePopup, usePopupData, useSavePopup} from "./usePopup";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import GameManagerEditModal from "../GameManagerEditModal";
import {REFRESH_TYPE_FUNCTION} from "../../../shared/utils/enum";
import TablePage from "../../../pages/tablePage/TablePage";
import {PopupMasterEntity} from "./PopupMasterEntity";
import {Switch} from "antd";
import {useOpenPopupData} from "../../logs/useTableData";
import {useReloadTime} from "../../serverInfo/useServerInfo";

const PopupMaster = () => {
    const [rowData, setRowData] = useState({});
    const { data: popupData, isLoading: isPopupLoading, error: popupError, refetch} = usePopupData();
    const { data: popupTableData, isLoading: isPopupTableData, error: popupTableDataError} = useOpenPopupData();
    const {data: reloadTimeData, isLoading: isReloadTimeData, error: reloadTimeDataError, refetch: reloadTimeDataRefetch} = useReloadTime();

    const { mutate: savePopup } = useSavePopup();
    const { mutate: deletePopup } = useDeletePopup();

    const processedData = useMemo(() => {
        if (!popupData) return [];
        return popupData.map(record => ({
            ...record,
            openLevel: popupTableData?.find(item => item.index === record.index)?.openLevel || ''
        }));
    }, [popupData, popupTableData]);

    // On/Off 스위치 토글 핸들러
    const handleSwitchChange = async (checked, record) => {
        try {
            if (record.end < dayjs().unix() && record.onOff !== 1) {
                toast.error('종료된 머지 이벤트는 On/Off 상태를 변경할 수 없습니다.');
                return;
            }

            record.onOff = checked ? 1 : 0;
            savePopup(record);
            await refetch();
        } catch (e) {
            toast.error('On/Off 변경 실패');
        }
    };

    const columns = [
        {
            title: '시퀀스',
            dataIndex: 'seq',
            key: 'seq',
            width: 80,
        },
        {
            title: '인덱스',
            dataIndex: 'index',
            key: 'index',
            width: 100,
        },
        {
            title: '이름',
            dataIndex: 'name',
            key: 'name',
            width: 300,
        },
        {
            title: '오픈 레벨',
            key: 'openLevel',
            dataIndex: 'openLevel',
            width: 100,
        },
        {
            title: 'On/Off',
            dataIndex: 'onOff',
            render: (_, record) => (
                <Switch
                    checked={record.onOff === 1}
                    checkedChildren="On"
                    unCheckedChildren="Off"
                    onChange={checked => handleSwitchChange(checked, record)}
                    onClick={(_, e) => e.stopPropagation()}
                />
            ),
            width: 100,
            filters: [
                {
                    text: 'On',
                    value: 1,
                },
                {
                    text: 'Off',
                    value: 0,
                },
            ],
        },
        {
            title: '시작 시간',
            dataIndex: 'begin',
            key: 'begin',
            width: 200,
            render: (_, {begin}) => {
                return dayjs.unix(begin).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        {
            title: '종료 시간',
            dataIndex: 'end',
            key: 'end',
            width: 200,
            render: (_, {end}) => {
                return dayjs.unix(end).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        {
            title: '메모',
            dataIndex: 'memo',
            key: 'memo',
            width: 200
        }
    ];

    const isLoading = isPopupLoading || isPopupTableData || isReloadTimeData;
    if (isLoading) return <IsLoading />
    const error = popupError || popupTableDataError || reloadTimeDataError;
    if (error) return <ErrorPage error={error} />;

    const props = {
        columns,
        rowData,
        setRowData,
        isLoading: isLoading,
        localData: processedData || [],
        entityModel: PopupMasterEntity,
        modal: (modalProps) => <GameManagerEditModal {...modalProps} handleClose={() => { modalProps.handleClose(); refetch(); }} />,
        modalOptions: {
            save: savePopup,
            delete: deletePopup,
            entity: PopupMasterEntity,
            isPopup: true
        },
        refreshTypeFunc: REFRESH_TYPE_FUNCTION.GAME_DATA,
        reloadTime: reloadTimeData?.game_data_sync_id,
        reloadTimeRefetch: reloadTimeDataRefetch
    }

    return (
        <TablePage
            {...props}
        />
    );
};

export default PopupMaster;